import { render, staticRenderFns } from "./RevenueManagerSetupActionTable.vue?vue&type=template&id=39982fe3&scoped=true&"
import script from "./RevenueManagerSetupActionTable.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupActionTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueManagerSetupActionTable.vue?vue&type=style&index=0&id=39982fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39982fe3",
  null
  
)

export default component.exports